import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import Loading from '../components/Loading'
import ErrorBoundary from './ErrorBoundary'
import KarteraAside from './kartera/KarteraAside'
import KarteraHeader from './kartera/KarteraHeader'

export interface KarteraAdminTemplateProps {
    loading?: boolean
    loged?: boolean
    padded?: boolean
    title?: string
    modal?: boolean
    children?: React.ReactNode
}

const KarteraAdminTemplate = ({ loading = false, loged = true, padded = true, title, modal, children }: KarteraAdminTemplateProps) => {
    const { user } = useAuth()
    const location = useLocation()

    useEffect(() => {
        if (modal) return undefined
        document.title = title || 'Kartera 365'
        return undefined
    }, [title, modal])

    if (loged && !user) {
        const next = `${location.pathname}${location.search}`
        return <Navigate to={`/login?url=${encodeURIComponent(next)}`} replace />
    }

    const content = (
        <>
            <Loading show={loading} />
            {children && <ErrorBoundary>{children}</ErrorBoundary>}
        </>
    )

    if (modal) {
        return <div className="flex-grow">{content}</div>
    }

    return (
        <div className="k-root flex h-dvh flex-col overflow-hidden bg-k-bg font-kartera text-k-ink">
            <KarteraHeader showNavToggle={loged} />
            <div className="flex min-h-0 flex-1">
                {loged && <KarteraAside />}
                <main
                    className={`flex min-h-0 min-w-0 flex-1 flex-col overflow-auto ${padded
                        ? 'gap-[18px] px-[clamp(16px,2.5vw,32px)] pb-10 pt-6'
                        : ''}`}
                >
                    {content}
                </main>
            </div>
        </div>
    )
}

export default KarteraAdminTemplate
